<template>
  <div class="neihbor_life">
    <ol>
      <li>
        <router-link to="/SeekHelp" replace>
          <div>
            <span>邻里求助</span>
          </div>
        </router-link>
      </li>
      <li>
        <router-link to="/Unused" replace>
          <div>
            <span>邻里闲置</span>
          </div>
        </router-link>
      </li>
      <li>
        <router-link to="/Repairs" replace>
          <div>
            <span>物业报修</span>
          </div>
        </router-link>
      </li>
    </ol>
    <!--显示子路由内容部分-->
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'NeighborLife'
  }
</script>

<style lang="scss" scoped>
  .neihbor_life {
    width: 100%;
    padding-top: 40px;
    ol {
      width: 100%;
      height: 50px;
      border-bottom: 1px solid #d7d7d7;
      list-style: none;
      background: #fff;
      right: 0;
      left: 0;
      position: fixed;
      z-index: 666;
      li {
        /*width: 24%;*/
        width: 32.2%;
        /*width: 48.5%;*/
        float: left;
        height: 50px;
        text-align: center;
        margin-left: 2px;
        border-right: 1px solid #d7d7d7;
        a {
          width: 100%;
          color: #000000;
          font-size: 15px;
          font-weight: bolder;
          text-align: center;
          text-decoration: none;
          div {
            height: 48px;
            span {
              line-height: 50px;
            }
          }
        }
        a.active {
          color: #0078de;
          font-size: 15px;
          font-weight: bolder;
          text-align: center;
          div {
            border-bottom: 3px solid #0078de;
          }
        }
      }
      li:first-child {
        border-left: none;
      }
      li:last-child {
        border-right: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/NeighborLife.vue